{
  "AF": "Afghanistan",
  "AL": "Albanie",
  "DZ": "Algérie",
  "AS": "Samoa américaines",
  "AD": "Andorre",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctique",
  "AG": "Antigua-et-Barbuda",
  "AR": "Argentine",
  "AM": "Arménie",
  "AW": "Aruba",
  "AU": "Australie",
  "AT": "Autriche",
  "AZ": "Azerbaïdjan",
  "BS": "Bahamas",
  "BH": "Bahreïn",
  "BD": "Bangladesh",
  "BB": "Barbade",
  "BY": "Bélarus",
  "BE": "Belgique",
  "BZ": "Belize",
  "BJ": "Bénin",
  "BM": "Bermudes",
  "BT": "Bhoutan",
  "BO": "Bolivie",
  "BQ": "Bonaire, Saint-Eustache et Saba",
  "BA": "Bosnie-Herzégovine",
  "BW": "Botswana",
  "BV": "Bouvet",
  "BR": "Brésil",
  "IO": "Indien",
  "BN": "Brunéi Darussalam",
  "BG": "Bulgarie",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "CV": "Cabo Verde",
  "KH": "Cambodge",
  "CM": "Cameroun",
  "CA": "Canada",
  "KY": "Caïmans",
  "CF": "République centrafricaine",
  "TD": "Tchad",
  "CL": "Chili",
  "CN": "Chine",
  "CX": "Christmas",
  "CC": "Cocos/ Keeling",
  "CO": "Colombie",
  "KM": "Comores",
  "CD": "Congo",
  "CG": "Congo",
  "CK": "Cook",
  "CR": "Costa Rica",
  "HR": "Croatie",
  "CU": "Cuba",
  "CW": "Curaçao",
  "CY": "Chypre",
  "CZ": "Tchéquie",
  "CI": "Côte d'Ivoire",
  "DK": "Danemark",
  "DJ": "Djibouti",
  "DM": "Dominique",
  "DO": "dominicaine",
  "EC": "Équateur",
  "EG": "Égypte",
  "SV": "El Salvador",
  "GQ": "Guinée équatoriale",
  "ER": "Érythrée",
  "EE": "Estonie",
  "SZ": "Eswatini",
  "ET": "Éthiopie",
  "FK": "Falkland/Malouines",
  "FO": "Féroé",
  "FJ": "Fidji",
  "FI": "Finlande",
  "FR": "France",
  "GF": "Guyane française",
  "PF": "Polynésie française",
  "TF": "Terres australes françaises",
  "GA": "Gabon",
  "GM": "Gambie",
  "GE": "Géorgie",
  "DE": "Allemagne",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Grèce",
  "GL": "Groenland",
  "GD": "Grenade",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernesey",
  "GN": "Guinée",
  "GW": "Guinée-Bissau",
  "GY": "Guyana",
  "HT": "Haïti",
  "HM": "Heard-et-Îles MacDonald",
  "VA": "Saint-Siège",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hongrie",
  "IS": "Islande",
  "IN": "Inde",
  "ID": "Indonésie",
  "IR": "Iran",
  "IQ": "Iraq",
  "IE": "Irlande",
  "IM": "Île de Man",
  "IL": "Israël",
  "IT": "Italie",
  "JM": "Jamaïque",
  "JP": "Japon",
  "JE": "Jersey",
  "JO": "Jordanie",
  "KZ": "Kazakhstan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KP": "Corée",
  "KR": "Corée",
  "KW": "Koweït",
  "KG": "Kirghizistan",
  "LA": "Lao",
  "LV": "Lettonie",
  "LB": "Liban",
  "LS": "Lesotho",
  "LR": "Libéria",
  "LY": "Libye",
  "LI": "Liechtenstein",
  "LT": "Lituanie",
  "LU": "Luxembourg",
  "MO": "Macao",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malaisie",
  "MV": "Maldives",
  "ML": "Mali",
  "MT": "Malte",
  "MH": "Marshall",
  "MQ": "Martinique",
  "MR": "Mauritanie",
  "MU": "Maurice",
  "YT": "Mayotte",
  "MX": "Mexique",
  "FM": "Micronésie",
  "MD": "Moldova",
  "MC": "Monaco",
  "MN": "Mongolie",
  "ME": "Monténégro",
  "MS": "Montserrat",
  "MA": "Maroc",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibie",
  "NR": "Nauru",
  "NP": "Népal",
  "NL": "Pays-Bas",
  "NC": "Nouvelle-Calédonie",
  "NZ": "Nouvelle-Zélande",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigéria",
  "NU": "Niue",
  "NF": "Norfolk",
  "MK": "Macédoine du Nord",
  "MP": "Mariannes du Nord",
  "NO": "Norvège",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palaos",
  "PS": "Palestine, État de",
  "PA": "Panama",
  "PG": "Papouasie-Nouvelle-Guinée",
  "PY": "Paraguay",
  "PE": "Pérou",
  "PH": "Philippines",
  "PN": "Pitcairn",
  "PL": "Pologne",
  "PT": "Portugal",
  "PR": "Porto Rico",
  "QA": "Qatar",
  "RO": "Roumanie",
  "RU": "Russie",
  "RW": "Rwanda",
  "RE": "Réunion",
  "BL": "Saint-Barthélemy",
  "SH": "Sainte-Hélène, Ascension et Tristan da Cunha",
  "KN": "Saint-Kitts-et-Nevis",
  "LC": "Sainte-Lucie",
  "MF": "Saint-Martin",
  "PM": "Saint-Pierre-et-Miquelon",
  "VC": "Saint-Vincent-et-les Grenadines",
  "WS": "Samoa",
  "SM": "Saint-Marin",
  "ST": "Sao Tomé-et-Principe",
  "SA": "Arabie saoudite",
  "SN": "Sénégal",
  "RS": "Serbie",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapour",
  "SX": "Saint-Martin",
  "SK": "Slovaquie",
  "SI": "Slovénie",
  "SB": "Salomon",
  "SO": "Somalie",
  "ZA": "Afrique du Sud",
  "GS": "Géorgie du Sud-et-les Îles Sandwich du Sud",
  "SS": "Soudan du Sud",
  "ES": "Espagne",
  "LK": "Sri Lanka",
  "SD": "Soudan",
  "SR": "Suriname",
  "SJ": "Svalbard et l'Île Jan Mayen",
  "SE": "Suède",
  "CH": "Suisse",
  "SY": "République arabe syrienne",
  "TW": "Taïwan",
  "TJ": "Tadjikistan",
  "TZ": "Tanzanie",
  "TH": "Thaïlande",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinité-et-Tobago",
  "TN": "Tunisie",
  "TM": "Turkménistan",
  "TC": "Turks-et-Caïcos",
  "TV": "Tuvalu",
  "TR": "Türkiye",
  "UG": "Ouganda",
  "UA": "Ukraine",
  "AE": "Émirats arabes unis",
  "GB": "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord",
  "UM": "Îles mineures éloignées des États-Unis",
  "US": "États-Unis d'Amérique",
  "UY": "Uruguay",
  "UZ": "Ouzbékistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Viet Nam",
  "VG": "Vierges britanniques",
  "VI": "Vierges des États-Unis",
  "WF": "Wallis-et-Futuna ",
  "EH": "Sahara occidental*",
  "YE": "Yémen",
  "ZM": "Zambie",
  "ZW": "Zimbabwe",
  "AX": "Åland"
}
